// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3EGk2","label":"Radio_label__3LaT7","checkMark":"Radio_checkMark__ALv82","disabled":"Radio_disabled__GD6bc"};